import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import {Navigator} from "./navigator";
import {SuccessPage} from "./components/SuccessPage";
import {FailPage} from "./components/FailPage";
import {SuccessPageStripe} from './components/SuccessPageStripe';
import {LanguageProvider} from './i18n/LanguageProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <LanguageProvider>
                <Routes>
                    <Route path="/" element={<Navigator/>}>
                        <Route index element={<App/>}/>
                        <Route path={'success'} element={<SuccessPage/>}/>
                        <Route path={'success-stripe'} element={<SuccessPageStripe/>}/>
                        <Route path={'fail'} element={<FailPage/>}/>
                    </Route>
                </Routes>
            </LanguageProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
